/** FAQ answers are plain text; `[label](/path)` marks a crawlable link to another page on this site. */
export type AnswerSegment = { text: string; href?: string };

// Same-site paths only: an answer must never become an off-site or script link.
const LINK = /\[([^\]\n]+)\]\((\/(?!\/)[^\s()]*)\)/g;

export function answerSegments(answer: string): AnswerSegment[] {
    const segments: AnswerSegment[] = [];
    let last = 0;
    for (const match of answer.matchAll(LINK)) {
        if (match.index > last) segments.push({ text: answer.slice(last, match.index) });
        segments.push({ text: match[1]!, href: match[2]! });
        last = match.index + match[0].length;
    }
    if (last < answer.length) segments.push({ text: answer.slice(last) });
    return segments;
}

export function answerPlainText(answer: string): string {
    return answer.replace(LINK, "$1");
}
